export default __webpack_public_path__ + "static/media/logo-icono.2b384123.svg";